<template>
    <div class="view">
        <div class="header">
            <vxe-form ref="formRef" :data="queryform" @submit="submitEvent" @reset="resetEvent">
                <vxe-form-item title="助记词" field="MnemonicPhrase"  :item-render="{}">
                    <template #default="params">
                        <vxe-input v-model="queryform.MnemonicPhrase"></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item title="名称" field="Name"  :item-render="{}">
                    <template #default="params">
                        <vxe-input v-model="queryform.Name"></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item align="center"  :item-render="{}">
                    <template #default>
                        <vxe-button type="submit" status="primary" content="查询"></vxe-button>
                        <vxe-button  status="error" content="添加" @click="handleAddnew"></vxe-button>
                    </template>
                </vxe-form-item>
            </vxe-form>
        </div>
        <div class="content">
            <div style="flex: 1;">
                <vxe-table stripe  :data="tableData" height="100%" max-height="100%" ref="tableRef" :loading="loading"
                    :row-config="{ isHover: true, isCurrent: true }" :cell-config="{ height: 30 }">

                    <vxe-column field="sP_BH" title="商品编号" width="80"></vxe-column>
                     <vxe-column field="sP_QM" title="商品全名" min-width="280" show-overflow></vxe-column>
                     <vxe-column field="sP_GG" title="商品名称" width="100"></vxe-column>
                    <vxe-column field="sP_MC" title="品牌" width="120"></vxe-column>
                    <vxe-column field="sP_XH" title="型号" width="260"></vxe-column>
                    <vxe-column field="sP_ZJC" title="助记词" min-width="160" show-overflow></vxe-column>
                    <vxe-column field="sP_DW" title="单位" width="80" align="center">
                        <template #default="{ row }">
                            <vxe-tag status="primary" size="mini">{{ row.sP_DW || '-' }}</vxe-tag>
                        </template>
                    </vxe-column>
                    <vxe-column field="sP_KC" title="库存数量" width="120" align="right">
                        <template #default="{ row }">
                            <span :style="{ color: row.sP_KC < 0 ? '#F56C6C' : '#67C23A', fontWeight: 'bold' }">
                                {{ row.sP_KC ?? 0 }}
                            </span>
                        </template>
                    </vxe-column>
                    <vxe-column title="操作" width="180" fixed="right">
                        <template #default="{ row }">

                            <vxe-button mode="text" status="warning" @click="handleEdit(row)">编辑</vxe-button>
                            <vxe-button mode="text" status="danger" @click="handleDelete(row)">删除</vxe-button>
                        </template>
                    </vxe-column>
                </vxe-table>
            </div>
            <div>
                <vxe-pager :current-page.sync="pageVO.currentPage" :page-size.sync="pageVO.pageSize"
                    :total="pageVO.total" @page-change="pageChange">

                </vxe-pager>
            </div>
        </div>
         <!-- 选择供货商* -->
    <vxe-modal v-model="showModel" width="800" height="300" destroy-on-close :title="initialData.usefule+'产品'" > 

      <template #default>
       <addProductComp v-model:initialData="initialData" @submit="handleCloseAddnew" />
      </template>
    </vxe-modal>
    </div>
</template>
<script setup>
import { ref, reactive, onMounted } from 'vue'
import request from '@/request/request'
import addProductComp from '@/components/addComp/addProductComp.vue'
import { VxeUI } from 'vxe-pc-ui'

const queryform = reactive({ MnemonicPhrase: '', Name: '',PageIndex:1, PageSize:50 })
const loading = ref(false)
const tableData = ref([])
const showModel = ref(false)
const initialData = reactive({ usefule: '新增', Product: {} })
const tableRef = ref(null)
import showMessage from '@/utils/showmessage'
const pageVO = reactive({
    total: 0,
    currentPage: 1,
    pageSize: 50
})

const pageChange = ({ pageSize, currentPage }) => {
    pageVO.currentPage = currentPage
    pageVO.pageSize = pageSize
    query()
}
const query = async () => {
    try {
        loading.value = true
        queryform.PageIndex = pageVO.currentPage
        queryform.PageSize = pageVO.pageSize
        const res = await request.post('/Product/GetProducts', queryform)
        tableData.value = res.data
        console.log(res)
        pageVO.total = res.totalCount

        loading.value = false
    }
    catch (error) {
        console.log(error)
        loading.value = false
    }
}
const submitEvent = async () => {
    showModel.value = false
    pageVO.currentPage = 1
    await query()
}
// ✅ 正确：直接调用 onMounted，不要赋值给变量
onMounted(async () => {
    await submitEvent()
})
const handleCloseAddnew = async () => {
    showModel.value = false
    await submitEvent()
}
const handleEdit = (row) => {
     initialData.usefule = '修改'
    initialData.Product = row
    showModel.value = true
}
const handleDelete =async (row) => {
     // 1. 使用 await 等待用户点击确认或取消
    const confirmResult = await VxeUI.modal.confirm({
      title: '删除确认',
      // 2. 使用模板字符串正确显示单号
      content: `确定要删除 ${row.sP_QM} 这个产品吗？`,
      mask: false,
      lockView: false
    });

    // 3. 判断用户是否点击了“确认”（vxe-table 通常返回 'confirm'）
    if (confirmResult === 'confirm') {
  
        try {
            loading.value = true
            let res = await request.delete(`/Product/Delete?id=${row.id}`)
            if (showMessage(res)) {
                
                await query()
            }
            loading.value = false
        } catch (error) {
            loading.value = false
            alert(error)
        }
    }
}
const handleAddnew = async () => {
    initialData.usefule = '新增'
    initialData.Product = {}
    showModel.value = true
}
</script>
<style scoped>
.view {
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.content {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    margin: 10px
}
</style>